import { getConfigValue } from './getConfigValue/index.js';
const DEFAULT_LOG_BASE_URL = 'https://www.cian.ru/ajax/log-error/';
export class AppInfo {
    application;
    mcsRunEnv;
    mcsRunEnvType;
    version;
    constructor(application) {
        this.application = application || 'unknown';
        this.init();
    }
    init() {
        this.refresh();
        document.addEventListener('DOMContentLoaded', () => {
            this.refresh();
        });
    }
    refresh() {
        this.mcsRunEnv = this.ensureMcsRunEnv();
        this.mcsRunEnvType = this.ensureMcsRunEnvType();
        this.version = this.ensureVersion();
    }
    get href() {
        return window.location.href;
    }
    get screenSize() {
        const { width, height } = window.screen;
        return `${width}/${height}`;
    }
    get availableScreenSize() {
        const { availWidth, availHeight } = window.screen;
        return `${availWidth}/${availHeight}`;
    }
    get logBaseUrl() {
        /**
         * Данный fallback необходим, так как есть сервисы, которые не используют @cian/web,
         * а разработчик может забыть установить переменную
         */
        if (!window._cianSystemLogger) {
            return DEFAULT_LOG_BASE_URL;
        }
        return (window._cianSystemLogger[this.application]?.logBaseUrl ||
            window._cianSystemLogger.v2?.logBaseUrl ||
            DEFAULT_LOG_BASE_URL);
    }
    ensureMcsRunEnv() {
        return getConfigValue(this.application, 'mcsRunEnv') || 'unknown';
    }
    ensureMcsRunEnvType() {
        return getConfigValue(this.application, 'mcsRunEnvType') || 'unknown';
    }
    ensureVersion() {
        return getConfigValue(this.application, 'version') || 'unknown';
    }
}
//# sourceMappingURL=AppInfo.js.map